"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckedElementsButton = exports.CheckedElementsText = exports.CheckedElementsBar = void 0;
const material_1 = require("@mui/material");
const styled_components_1 = __importStar(require("styled-components"));
exports.CheckedElementsBar = styled_components_1.default.div(({ theme: { palette, shape } }) => (0, styled_components_1.css) `
    display: flex;
    background-color: ${palette.grey[300]};
    padding: 7px;
    justify-content: center;
    border-radius: ${shape.borderRadius}px;
    margin-bottom: 8px;
  `);
exports.CheckedElementsText = (0, styled_components_1.default)(material_1.Typography)(({ theme: { palette } }) => (0, styled_components_1.css) `
    font-weight: 600;
    color: ${palette.grey[900]};
  `);
exports.CheckedElementsButton = (0, styled_components_1.default)(material_1.Typography)(({ theme: { palette } }) => (0, styled_components_1.css) `
    font-weight: 600;
    color: ${palette.primary.main};
    margin-left: 8px;
    cursor: pointer;
  `);
